import { useMemo } from 'react';
import { useTheme, useMediaQuery } from '@mui/material';
import { Comment } from './types';

export const useComments = (comments: Comment[]) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const processedComments = useMemo(() => {
    return comments.map(comment => ({
      ...comment,
      content: isMobile && comment.content.length > 200 
        ? `${comment.content.substring(0, 200)}...` 
        : comment.content
    }));
  }, [comments, isMobile]);

  return {
    processedComments,
    isMobile,
    theme,
  };
};
